<template>
  <div class="site-footer">
    
  </div>
</template>

<script>

export default {
  name: 'site-footer',

  data() {
    return {
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  },
  directives: {
  },
};
</script>



// WEBPACK FOOTER //
// SiteFooter.vue?511e8111